import { useAppContext } from "../../../../App";
import { authorize } from "../../../../Core";
import { roles } from "../../../../config/constants";
import { useAbmContext } from "../../../../views/abm/useAbmComponent";
import { ActionButton } from "../../../helpers";
import { CancelIcon } from "../../../icons";

export const RechazarFactura = ({params}) => {
  const { setShowFacturaRechazo } = useAbmContext();
  const { claims: { rol } } = useAppContext();

  if(!authorize({rol, inRoles: [roles.LIQUIDADOR, roles.ADMINISTRATIVO_CENTRAL]})){
    return <></>
  }
  const enabled = rol === roles.LIQUIDADOR || rol === roles.ADMINISTRATIVO_CENTRAL;

  const handleClick = () => {
    setShowFacturaRechazo(true);
  }
  return <ActionButton iconButton enabled={enabled} Icon={CancelIcon} onClick={handleClick}/>
}
